import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.tsx';
import { installChunkReloadHandler } from './lib/chunkReload.ts';
import './styles.css';
import 'material-symbols/rounded.css';

// Recover from stale-deploy chunk errors (see chunkReload.ts). Must run before
// the first lazy import() can fail.
installChunkReloadHandler();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
